import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { About } from './components/About';
import { Buy } from './components/Buy';
import { Sell } from './components/Sell';
import { MyCatawiki } from './components/MyCatawiki';
import { SETTINGS } from './constants';
import { useLocale } from '../../../hooks/useLocale';
export const LinksSection = () => {
    const locale = useLocale();
    const { show_press_page: showPress, show_collectors_platform: showCollectors, show_category_guidelines: showCategoryGuidelines, } = useMemo(() => SETTINGS[locale], [locale]);
    return (_jsx("div", { className: "u-wrapper", children: _jsxs("div", { className: "u-flex u-flex--justify-content-space-between u-flex--wrap u-g-xl", children: [_jsx(About, { showPress: showPress, showCollectors: showCollectors }), _jsx(Buy, {}), _jsx(Sell, { showCategoryGuidelines: showCategoryGuidelines }), _jsx(MyCatawiki, {})] }) }));
};
//# sourceMappingURL=LinksSection.js.map